import React from "react";
import { TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ja } from "date-fns/locale";

// 単一の日付を選ぶための共通コンポーネント。
//
// 既存の FromToDatePickersForNotice と同じ @mui/x-date-pickers(v5) +
// AdapterDateFns を使い、見た目とフォーマットを揃えている。
// 検索フィルタの期間入力(DateRangeWithPresets)もこれを2つ並べて使っている。
//
// 注: v5 のロケール指定は `adapterLocale`(v4 の `locale` は無視される)。
//     入力欄のフォーマット指定は `inputFormat`(v6 で `format` に改名)。
const SingleDateField = (props) => {
  const {
    label,
    value,
    onChange,
    disabled = false,
    minDate,
    maxDate,
    width = 150,
    placeholder = "----/--/--",
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
      <DatePicker
        label={label}
        value={value ?? null}
        onChange={onChange}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        inputFormat="yyyy/MM/dd"
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            inputProps={{
              ...params.inputProps,
              placeholder,
            }}
            sx={{
              width,
              "& .MuiInputBase-input": {
                paddingTop: 0,
                paddingBottom: 0,
                height: "38px",
                fontSize: "14px",
              },
              "& .MuiInputLabel-root": { fontSize: "14px" },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default SingleDateField;
